/**
 * Get Recently Viewed Products Action
 * Triggered by: arc:action:recentlyViewedGet
 */

export const runRecentlyViewedGet = async (data = {}) => {
    try {
        const { limit = 10 } = data;

        // Get products from localStorage
        const products = JSON.parse(localStorage.getItem("recentlyviewed_products") || "[]");

        if (products && products.length > 0) {
            // Process products to ensure they have proper image property
            const processedProducts = products.map((product, index) => {
                // Ensure the image property is set correctly
                if (product && !product.image && product.featuredImage?.src) {
                    product.image = product.featuredImage.src;
                }
                return product;
            }).filter(product => product && product.id); // Filter out any invalid products

            // Apply limit if specified
            const limitedProducts = limit ? processedProducts.slice(0, limit) : processedProducts;

            // Dispatch success event
            window.dispatchEvent(new CustomEvent('recentlyViewed:fetched', {
                detail: {
                    products: limitedProducts,
                    total: processedProducts.length
                }
            }));

            return {
                success: true,
                products: limitedProducts,
                total: processedProducts.length,
                message: 'Recently viewed products retrieved successfully'
            };
        } else {
            // No products found
            return {
                success: true,
                products: [],
                total: 0,
                message: 'No recently viewed products found'
            };
        }

    } catch (error) {
        console.error('Recently Viewed Get error:', error);
        
        // Dispatch error event
        window.dispatchEvent(new CustomEvent('recentlyViewed:error', {
            detail: {
                error: error.message,
                action: 'get'
            }
        }));

        return {
            success: false,
            error: error.message,
            products: []
        };
    }
};

export default runRecentlyViewedGet;
